// Module
var code = "<sb-app-visualization-editor></sb-app-visualization-editor> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/states/visualizations/states/visualizationEditor/visualization_editor.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;